export default {
      id: "icon-settings-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "icons.svg#icon-settings",
      toString: function () {
        return this.url;
      }
    }